import { render, staticRenderFns } from "./AskBill.vue?vue&type=template&id=a4312478&scoped=true&"
import script from "./AskBill.vue?vue&type=script&lang=js&"
export * from "./AskBill.vue?vue&type=script&lang=js&"
import style0 from "./AskBill.vue?vue&type=style&index=0&id=a4312478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4312478",
  null
  
)

export default component.exports